import { updateUi } from "./ui-stateful";
import { getVariantId, getStepTypes } from './utilities';
/* -----------------------------------------------------------------
                        State
----------------------------------------------------------------- */

// Main configurator state
export let state = {
    configuratorIsOpen: false,
    currentStep: 1,
    currentSubStep: 1,
    stepData : [],
    chosenOptions: [],
    infoPopup: null,
    techSpecsIsOpen: false,
    product : null,
    downloadsIsOpen : false,
    hoverInfo: null,
    stepExpanded: false,
    variantImages : {},
    variantImageId : 0,
    firstRun: true,
};

// Main configurator state
export let previousState = {};

export function setState(newState) {
    previousState = { ...state };
    state = { ...newState };
    updateUi(state, previousState);
}
